import { useEffect } from 'react';

export default function ArticleMeta({ publishedTime, modifiedTime }) {
    useEffect(() => {
        const nodes = [];

        const addMeta = (property, content) => {
            const meta = document.createElement('meta');
            meta.setAttribute('property', property);
            meta.setAttribute('content', content);
            meta.dataset.seoArticle = property;
            document.head.appendChild(meta);
            nodes.push(meta);
        };

        if (publishedTime) {
            addMeta('article:published_time', publishedTime);
        }

        if (modifiedTime) {
            addMeta('article:modified_time', modifiedTime);
        }

        return () => {
            nodes.forEach((node) => node.remove());
        };
    }, [publishedTime, modifiedTime]);

    return null;
}
